var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pencil-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M7.99961 14.8H14.3996M9.99961 3.20001L12.7996 5.60001M2.79961 10.4L10.6872 2.23696C11.5365 1.38769 12.9134 1.38769 13.7627 2.23696C14.6119 3.08622 14.6119 4.46316 13.7627 5.31242L5.59961 13.2L1.59961 14.4L2.79961 10.4Z",
    stroke: "#A9A9AE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.0f98b2ee5875893b11e3d256eec48080.svg";
export { ForwardRef as ReactComponent };